import { TagsOutlined } from '@ant-design/icons';
import { BookmarkIcon } from 'lucide-react';
import { useCallback } from 'react';

import ManualIcon from '@/assets/icons/ManualIcon';
import AIIcon from '@/components/Badge/AIBadge/AIIcon';
import useColor from '@/hooks/domain/useColor';
import { TOPIC_2_TYPE } from '@/types/taxonomyConst';

const useTopicTypeIcon = () => {
  const colors = useColor();
  const getIcons = useCallback(
    (
      type: TOPIC_2_TYPE,
      options: {
        size?: number;
        color?: string;
      } = {},
    ) => {
      const { size = 16, color = colors.primary100 } = options;
      const iconColor = color;
      switch (type) {
        case TOPIC_2_TYPE.AI:
          return <AIIcon style={{ color: iconColor, fontSize: size }} />;
        case TOPIC_2_TYPE.RULE:
          return <TagsOutlined style={{ color: iconColor, fontSize: size }} />;
        case TOPIC_2_TYPE.MANUAL:
          return (
            <ManualIcon
              width={size}
              height={size}
              style={{ color: iconColor }}
            />
          );
        case TOPIC_2_TYPE.SAVED_TOPIC:
          return <BookmarkIcon style={{ color: iconColor, fontSize: size }} />;
        default:
          throw new Error(`Invalid topic type: ${type}`);
      }
    },
    [colors.primary100],
  );
  return getIcons;
};

export default useTopicTypeIcon;
